import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider } from '@mui/material/styles';
import { useAtomValue } from 'jotai';
import { useEffect, type ReactNode } from 'react';

import { colorModeAtom } from '@/store';
import { themes } from '@/theme';

/**
 * Resolves the stored preference (`system` by default) to the light or the dark Spectrum theme.
 * The switch itself sits in the user menu.
 */
export function AppThemeProvider({ children }: { children: ReactNode }) {
  const preference = useAtomValue(colorModeAtom);
  const systemDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
  const mode = preference === 'system' ? (systemDark ? 'dark' : 'light') : preference;
  const theme = themes[mode];

  // The browser chrome (scrollbars, form controls outside MUI, the address bar on a phone) follows.
  useEffect(() => {
    document.documentElement.style.colorScheme = mode;
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', theme.palette.background.paper);
  }, [mode, theme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
